import IconItem from './icon_item';

export default class Clearformat extends IconItem {
  constructor() {
    super('clearformat');
  }
}
